import { Alert, Button, Spin } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useAuthSession } from '@/lib/session'
import FeatureThemeProvider from '@/components/FeatureThemeProvider'
import { useCapacitySettings } from '../hooks'
import { SetupPage } from '../setup/page'

export function CapacityPlannerSettingsPage() {
  const navigate = useNavigate()
  const session = useAuthSession()
  const clientId = session?.currentClientId ?? ''
  const { data: settings, isLoading, isError, refetch } = useCapacitySettings(clientId)

  if (isLoading) {
    return (
      <FeatureThemeProvider featureKey="pracPlanner" withAntd className="flex justify-center p-12">
        <Spin size="large" />
      </FeatureThemeProvider>
    )
  }

  if (isError) {
    return (
      <FeatureThemeProvider featureKey="pracPlanner" withAntd className="p-6">
        <Alert
          type="error"
          message="Failed to load PracPlanner settings"
          action={<Button size="small" onClick={() => refetch()}>Retry</Button>}
        />
      </FeatureThemeProvider>
    )
  }

  return (
    <SetupPage
      mode="settings"
      initialSettings={settings}
      onCancel={() => navigate('/capacity-planner')}
      onComplete={async () => {
        await refetch()
        navigate('/capacity-planner')
      }}
    />
  )
}
